import { SET_OPEN_TAB, SET_TV_SEC_MODE } from "actions/secretaryMode";

export const setOpenTab = (tab) => {
	return {
		type: SET_OPEN_TAB,
		payload: tab,
	};
};

export const setTvSecMode = (mode) => {
	return {
		type: SET_TV_SEC_MODE,
		payload: mode,
	};
};
